/*
 * PRD-037 — App SEPARADA del portal del partner. Router + auth + LAYOUT propios; NO importa el
 * AuthContext/router/axiosInstance del panel. Se monta desde src/index.tsx para /partner y
 * /pre-registro. Layout con navegacion + paginas de gestion (dashboard, comercios, alta, detalle).
 */
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@plick/ui';
import { plickTheme } from '@theme/index';
import { PartnerAuthProvider, usePartnerAuth } from './PartnerAuthContext';
import PartnerLayout from './PartnerLayout';
import PartnerLogin from './pages/PartnerLogin';
import Dashboard from './pages/Dashboard';
import CommerceList from './pages/CommerceList';
import CreateCommerce from './pages/CreateCommerce';
import CommerceDetail from './pages/CommerceDetail';
import PartnerDraftMenu from './pages/PartnerDraftMenu';
import ConfigureCommerce from './pages/ConfigureCommerce';
import ClaimPage from './pages/ClaimPage';

// Si no hay sesion de partner → login; si hay → layout con las paginas de gestion (Outlet).
const ShellGate = () => {
  const { token } = usePartnerAuth();
  return token ? <PartnerLayout /> : <PartnerLogin />;
};

const DraftGate = () => {
  const { token } = usePartnerAuth();
  return token ? <PartnerDraftMenu /> : <Navigate to="/partner" replace />;
};

const ConfigureGate = () => {
  const { token } = usePartnerAuth();
  return token ? <ConfigureCommerce /> : <Navigate to="/partner" replace />;
};

const router = createBrowserRouter([
  { path: '/pre-registro/:token', element: <ClaimPage /> },
  { path: '/partner/draft/:id/menu', element: <DraftGate /> },
  { path: '/partner/draft/:id/configurar', element: <ConfigureGate /> },
  {
    path: '/partner',
    element: <ShellGate />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'comercios', element: <CommerceList /> },
      { path: 'comercios/nuevo', element: <CreateCommerce /> },
      { path: 'comercios/:id', element: <CommerceDetail /> },
    ],
  },
  { path: '*', element: <Navigate to="/partner" replace /> },
]);

// ThemeProvider en el root: los componentes canónicos del panel que el partner reusa
// (Button/FieldV4/TextInputV4/Select son inline-style puros y NO lo necesitan, pero ScheduleManager
// y el SmartMenu del wizard leen @plick/ui Tooltip/Switch/Input) requieren el tema. Es SOLO contexto
// de tema — no se monta Redux/AuthContext/Chatwoot/PostHog (la app sigue separada).
const PartnerApp = () => (
  <ThemeProvider theme={plickTheme}>
    <PartnerAuthProvider>
      <RouterProvider router={router} />
    </PartnerAuthProvider>
  </ThemeProvider>
);

export default PartnerApp;
